import { render, staticRenderFns } from "./TransactionTypesModal.vue?vue&type=template&id=f6b8112a&scoped=true"
import script from "./TransactionTypesModal.vue?vue&type=script&lang=js"
export * from "./TransactionTypesModal.vue?vue&type=script&lang=js"
import style0 from "./TransactionTypesModal.vue?vue&type=style&index=0&id=f6b8112a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b8112a",
  null
  
)

export default component.exports